import React from 'react';
import { Card, Icon } from 'components';
import styled from 'styled-components';
import { Flex } from '@bb/elements-web';
import AssetSearch from './AssetSearch';
import NewAssetDropdown from './NewAssetDropdown';
import type { AssetExplorerView } from '..';

type AssetExplorerHeaderProps = {
  isAdmin: boolean;
  explorerView: AssetExplorerView;
  onViewChange: (view: AssetExplorerView) => void;
  onNewAssetClick: (assetType: 'folder' | 'fileUpload' | 'videoLink') => void;
  onSearchSelect: ({ id, url }: { id: string; url?: string }) => void;
};

const AssetExplorerHeader = ({
  isAdmin,
  explorerView,
  onViewChange,
  onNewAssetClick,
  onSearchSelect,
}: AssetExplorerHeaderProps) => (
  <StyledCard>
    <Flex justify="space-between" align="center">
      <StyledSearchContainer>
        <AssetSearch onSelect={onSearchSelect} />
      </StyledSearchContainer>
      <StyledActionContainer gap={4} justify="flex-end" align="center">
        <StyledIconContainer
          $isActive={explorerView === 'grid'}
          onClick={() => onViewChange('grid')}
        >
          <Icon
            color={explorerView === 'grid' ? 'primary' : null}
            type="antdAppstoreOutlined"
            width={20}
          />
        </StyledIconContainer>
        <StyledIconContainer
          $isActive={explorerView === 'list'}
          onClick={() => onViewChange('list')}
        >
          <Icon
            color={explorerView === 'list' ? 'primary' : null}
            type="antdUnorderedListOutlined"
            width={20}
          />
        </StyledIconContainer>
        {isAdmin && <NewAssetDropdown onNewAssetClick={onNewAssetClick} />}
      </StyledActionContainer>
    </Flex>
  </StyledCard>
);

export default AssetExplorerHeader;

const StyledCard = styled(Card)`
  && {
    padding: 0;
  }

  && {
    .ant-card-body {
      padding: 10px 15px;
    }
  }
`;

const StyledSearchContainer = styled.div`
  flex: 0 1 70%;
`;

const StyledActionContainer = styled(Flex)`
  flex: 1 0 30%;
  margin-left: 5px;
`;

const StyledIconContainer = styled.span<{ $isActive: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`;
